import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from '@mui/material';
import { ExtraTripsCompletionDeadlines } from '@/constants/ApprovalConstants';
import { formatddMMyyyy } from '@/utils/formatDate';
import LightTooltip from './LightTooltip';

interface Props {
	completionDeadlines: ExtraTripsCompletionDeadlines;
}

const ApprovalCompletionDeadlinesLevelTooltipIcon = ({
	completionDeadlines,
}: Props) => {
	if (!completionDeadlines) {
		return <></>;
	}
	return (
		<LightTooltip
			title={
				<div
					style={{
						whiteSpace: 'pre-line',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
						justifyContent: 'space-between',
						padding: '8px',
					}}
				>
					<div className="text-sm font-medium text-[#193CB9] mb-2">
						Prazos de aprovação
					</div>
					<div className="flex flex-col gap-2"></div>
					<table>
						<thead>
							<tr>
								<th className="text-left">Ida extra</th>
								<th className="text-left">Prazo</th>
								<th className="text-left">Status</th>
							</tr>
						</thead>
						<tbody>
							{Object.entries(completionDeadlines).map(([day, deadline]) => (
								<tr key={day}>
									<td className="pr-3">{formatddMMyyyy(day)}</td>
									<td className="pr-3">{formatddMMyyyy(deadline.date)}</td>
									{deadline.expired ? (
										<td className="text-[#9E0000]">Expirada</td>
									) : (
										<td className="text-[#363636]">Pendente</td>
									)}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			}
			placement="top"
			arrow
		>
			<IconButton
				sx={{ height: '2rem', width: '2rem' }}
				aria-label="information"
				size="small"
				color="primary"
			>
				<InfoIcon fontSize="inherit" />
			</IconButton>
		</LightTooltip>
	);
};

export default ApprovalCompletionDeadlinesLevelTooltipIcon;
